import Vue from 'vue';

const decode = (html) => {
  if (!html || typeof html !== 'string') {
    return html;
  }

  const temporaryBodyDocument = document.implementation.createHTMLDocument('New').body;

  temporaryBodyDocument.innerHTML = html;

  return temporaryBodyDocument.textContent || temporaryBodyDocument.innerText || '';
};

Vue.filter('decode', (string) => {
  return decode(string);
});
